import http from './http';
import {User, UserCreate} from '../types';

export async function listUsers(): Promise<User[]> {
  const res = await http.get<User[]>('/users');
  return res.data;
}

export async function createUser(payload: UserCreate): Promise<User> {
  const res = await http.post<User>('/users', payload);
  return res.data;
}

export async function resetUserPassword(id: string, password: string): Promise<void> {
  await http.post(`/users/${id}/reset-password`, { password });
}

export async function deleteUser(id: string): Promise<void> {
  await http.delete(`/users/${id}`);
}
